@let navItem = item();

@if (navItem.path) {
  <a
    class="menu-item"
    data-testid="nav-item"
    tpPlacement="right"
    [id]="idx() + '__' + navItem.code"
    [routerLink]="link()"
    [attr.aria-current]="isActive() ? 'page' : null"
    [tp]="navItem.displayName"
    [tpIsEnabled]="!menuExpanded() && !!navItem.displayName"
    [tpTippyProps]="{ touch: false }"
    [class.menu-item-expanded]="menuExpanded()"
    [class.menu-item--separator-above]="navItem.code === 'settings' && itemListLength() > 2"
    [class.first-agency-element]="isFirstElement() && isAgencyPlatform()"
    (click)="onItemSelected()"
  >
    <ng-container [ngTemplateOutlet]="content" />
  </a>
} @else {
  <button
    class="menu-item"
    data-testid="nav-item"
    type="button"
    tpPlacement="right"
    [id]="idx() + '__' + navItem.code"
    [attr.aria-expanded]="navItem.code === 'nest' ? nestPanelExpanded() : null"
    [attr.aria-disabled]="navItem.code === 'filters' && filtersDisabled() ? 'true' : null"
    [tp]="navItem.displayName"
    [tpIsEnabled]="!menuExpanded() && !!navItem.displayName"
    [tpTippyProps]="{ touch: false }"
    [class.menu-item-expanded]="menuExpanded()"
    [class.menu-item--nest]="navItem.code === 'nest'"
    [class.menu-item--separator-below]="navItem.code === 'filters' && itemListLength() > 2"
    [class.menu-item-disabled]="navItem.code === 'filters' && filtersDisabled()"
    [class.first-agency-element]="isFirstElement() && isAgencyPlatform()"
    (click)="onItemSelected()"
  >
    <ng-container [ngTemplateOutlet]="content" />
  </button>
}

<ng-template #content>
  <span
    [class]="'icon ' + navItem.iconName"
    [class.active]="isActive()"
    [class.has-filter-count]="navItem.hasFilterCount && filterCount() > 0"
  ></span>
  <span class="display-name" [class.active]="isActive()">{{ navItem.displayName }}</span>
</ng-template>
